import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";
import SummaryApi from '../common';
import AdminSubCategoryCard from '../components/AdminSubCategoryCard';
import UploadSubCategory from '../components/UploadSubCategory';
import { toast } from 'react-toastify';


const AllSubCategory = () => {
  const [openUploadBrand, setOpenUploadBrand] = useState(false);
  const [allSubCategory, setAllSubCategory] = useState([]);

  const fetchAllSubCategory = async () => {
    try {
      const response = await fetch(SummaryApi.adminSubCategory.url, {
        headers: {
          'Authorization': 'Bearer oakyaecom_no_units_916',
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch subcategories');
      }
      
      const dataResponse = await response.json();
  
      // Reverse the data
      const reversedSubCategories = (dataResponse?.data || []).reverse();
      setAllSubCategory(reversedSubCategories); // Set reversed data
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      // Optionally, you can use a notification or a toast to show the error
      toast.error(`Failed to fetch subcategories: ${error.message}`);
    }
  };
  

  useEffect(() => {
    fetchAllSubCategory();
  }, []);

  return (
    <div>
      <div className='bg-white py-2 px-4 flex flex-col sm:flex-row justify-between items-center'>
        <h2 className='font-bold text-lg'>All Sub Categories</h2>
        <div className='flex'>
          <div className='flex items-center mx-2 text-sm '>
            <div>Actice</div> 
            <div className='mx-2 text-lg text-[#008000]'><FaCheckCircle/></div> 
            <div className='ml-2'>InActive</div> 
            <div className='mx-2 text-lg text-[#D22B2B]'><FaTimesCircle /></div>
          </div>
          <button
            className='border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1 px-3 rounded-full'
            onClick={() => setOpenUploadBrand(true)}
          >
            Upload Sub Category
          </button>
        </div>
        
      </div>

      {/* Display categories using AdminCategoryCard */}
      <div className='flex items-center flex-wrap gap-5 py-4 overflow-y-scroll'>
        {allSubCategory.map((product, index) => (
          <AdminSubCategoryCard key={index} data={product} fetchdata={fetchAllSubCategory} />
        ))}
      </div>

      {/* Upload product component */}
      {openUploadBrand && <UploadSubCategory onClose={() => setOpenUploadBrand(false)} fetchdata={fetchAllSubCategory} />}
    </div>
  );
};

export default AllSubCategory;
